export const fontFamily = "'Lato', sans-serif"

export const lineHeight = '17px'

export const fontWeightRegular = '400'
export const fontWeightBold = '700'
